import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAxisXSizeS from './IconAxisX_size_s';

const props: CreateIconArguments = {
  l: IconAxisXSizeS,
  m: IconAxisXSizeS,
  s: IconAxisXSizeS,
  xs: IconAxisXSizeS,
  name: 'IconAxisX',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
